import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UsersListOfSpecialistsType } from './types';
import { ISpecialist } from '../specialists/types';
import { updateArray } from '../../utils/updateArray';
import { fetchLastContract, fetchSpecialistByID } from '../loadedSpecialists/thunk';
import { updateReview } from '../specialistReviews/thunk';

export const FETCHING_STATUS = {
  start: 'start',
  pending: 'pending',
  fullfiled: 'fullfield',
};

interface UpdatePayload {
  field: keyof ISpecialist;
  value: any;
  data: Partial<ISpecialist>;
}

const usersPsychologistsReducer = createSlice({
  name: 'usersPsychologists',
  initialState: null as Array<UsersListOfSpecialistsType> | null,
  reducers: {
    getUsersPsychologistsList: (state, action: PayloadAction<Array<UsersListOfSpecialistsType>>) => {
      return [...action.payload.filter(Boolean)];
    },
    addUsersPsychologist: (state, action: PayloadAction<UsersListOfSpecialistsType>) => {
      if (!state?.find((psy) => psy.id === action.payload.id)) {
        state?.push(action.payload);
      }
    },
    updateUsersSpecialistBy: (state, action: PayloadAction<UpdatePayload>) => {
      const { field, value, data } = action.payload;
      // TODO: fix type in the future
      if (!state) return state;
      return updateArray<ISpecialist>(
        state,
        (specialist) => specialist[field] === value, // Condition to find the specialist
        data // Data to update
      );
    },
    setUsersPsychologists: (state, action: PayloadAction<Array<UsersListOfSpecialistsType> | null>) => action.payload,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpecialistByID.fulfilled, (state, action) => {
        if (state) {
          state.forEach((item) => {
            if (item.id === action.payload.id) {
              item.is_disabled = action.payload.is_disabled;
              item.client = action.payload.client;
            }
          });
        }
      })
      .addCase(fetchLastContract.fulfilled, (state, action) => {
        if (!state || !action.payload) return;
        return state.map((item) => {
          if (item.id === action.payload.specialist_id) {
            return {
              ...item,
              client: {
                specialist_client_contract_status: action.payload.status,
                specialist_client_contract_id: action.payload.id,
              },
            };
          }
          return item;
        });
      })
      .addCase(updateReview.fulfilled, (state, action) => {
        if (!state || !action.payload) return;

        return state.map((item) => {
          if (item.id === action.payload.specialist_id) {
            return {
              ...item,
              reviews_count: action.payload.specialist.reviews_count,
              reviews_average_rating: action.payload.specialist.reviews_average_rating,
              reviews_count_by_stars: action.payload.specialist.reviews_count_by_stars,
            };
          }
          return item;
        });
      });
  },
});

export const { getUsersPsychologistsList, addUsersPsychologist, setUsersPsychologists, updateUsersSpecialistBy } =
  usersPsychologistsReducer.actions;

export default usersPsychologistsReducer.reducer;
